import React, { Component } from "react";
import { connect } from "react-redux";
import { getMaxRegionsNo } from "../../store/sales/selectors";
import { fetchMonitorLocations } from "../../store/monitor_locations/operations";
import {
  isFetchingMonitorLocations,
  getMonitorLocations,
  getOrderOfMonitorLocation
} from "../../store/monitor_locations/selectors";
import {
  getSelectedWebsiteDomain,
  getSelectedWebsiteRegions,
  isUpdatingLocations
} from "../../store/tracked_websites/selectors";
import { getTrackedWebsites, updateSettings } from "../../store/tracked_websites/operations";
import LocationTab from "../../components/DashboardSettings/LocationTab";

export class Location extends Component {
  componentDidMount() {
    this.props.fetchMonitorLocations();
  }
  render() {
    return (
      <LocationTab
        domain={this.props.domain}
        isLoading={this.props.isLoading}
        maxRegionsNo={this.props.maxRegionsNo}
        locations={this.props.monitorLocations}
        locationsOrder={this.props.monitorLocationsOrder}
        mainLocation={this.props.selectedWebsiteRegions[0]}
        additionalLocations={this.props.selectedWebsiteRegions.slice(1)}
        updateLocations={this.props.updateSettings}
        isUpdatingLocations={this.props.isUpdatingLocations}
      />
    );
  }
}

const mapStateToProps = state => ({
  domain: getSelectedWebsiteDomain(state),
  isLoading: isFetchingMonitorLocations(state),
  maxRegionsNo: getMaxRegionsNo(state),
  monitorLocations: getMonitorLocations(state),
  monitorLocationsOrder: getOrderOfMonitorLocation(state),
  selectedWebsiteRegions: getSelectedWebsiteRegions(state),
  isUpdatingLocations: isUpdatingLocations(state)
});

export default connect(mapStateToProps, { fetchMonitorLocations, getTrackedWebsites, updateSettings })(Location);
